import {
  Button,
  Table,
  DatePicker,
  Select,
  Modal,
  Form,
  Tabs,
  Dropdown,
  Menu,
  Popconfirm,
  message,
} from "antd";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  LeftOutlined,
  LoadingOutlined,
  ReloadOutlined,
  RightOutlined,
} from "@ant-design/icons";
import type { FormProps } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination, { PaginationProps } from "antd/es/pagination";
import validateMessages from "../../utils/validate";
import ClientInfoForm from "../../components/Accounts/ClientInfoForm";
import FiltersForm from "../../components/Accounts/FiltersForm";
import IncomeShareForm from "../../components/Accounts/IncomeShareForm";
import BankDetailsForm from "../../components/Accounts/BankDetailsForm";
import createIncomeShare, {
  addSpecificIncomeShare,
  editIncomeShare,
  resetIncomeShare,
  retrieveIncomeShare,
} from "../../redux/actions/incomeShareActions";
import createBankAccDetails, {
  editBankAccDetails,
} from "../../redux/actions/bankAccActions";
import {
  createAccount,
  editClientFilter,
  editClientInfo,
  getClients,
  getClientTypes,
  getIsClientShareExist,
  resetClientFilterEditError,
  resetClients,
  resetExistedClientShare,
} from "../../redux/actions/accountActions";
import { RootState } from "../../redux/rootReducer";
import tableUtils from "../../utils/tableUtils";
import { ClientColumn } from "../../shared/table/columns";
import TrackIncomeForm from "../../components/Accounts/TrackIncomeForm";
import SearchComponent from "../../components/_shared/SearchComponent";
import icons from "../../shared/icons";
import {
  AccountType,
  Actions,
  ClientKeys,
  PaymentCalculationStatus,
} from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";
import cells from "../../shared/table/cells";

const { RangePicker } = DatePicker;
const { Option } = Select;

// const onEdit = (record: DataType) => {
//   console.log("on edit ", record);
// };

const formProps: FormProps = {
  layout: "vertical",
  name: "clientForm",
  validateMessages,
  preserve: false,
};

const Accounts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState<null | any>(null);
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [clientForm] = Form.useForm();
  const [filtersForm] = Form.useForm();
  const [incomeShareForm] = Form.useForm();
  const [bankForm] = Form.useForm();
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [page, setPage] = useState(1);
  const [effect, setEffect] = useState(false);
  const [clientFormValues, setClientFormValues] = useState<any>(null);
  const [trackformValues, setTrackformValues] = useState<any>(null);
  const [filtersFormValues, setFiltersFormValues] = useState<any>(null);
  const [incomeShareFormValues, setIncomeShareFormValues] = useState<any>(null);
  const [bankFormValues, setBankFormValues] = useState<any>(null);
  const [clientNameSort, setClientNameSort] = useState("name");
  const [refreshkey, setRefreshKey] = useState<any>(null);
  const { newIncomeShare, specificIncomeShareSuccess } = useSelector(
    (state: RootState) => state.incomeShare,
  );
  const { newBankAcc } = useSelector((state: RootState) => state.bankAcc);
  const {
    clients,
    clientsPending,
    clientTypes,
    clientsCount,
    pending,
    fulfilled,
    clientInfoSuccess,
    clientInfoPending,
    clientFilterEditError,
  } = useSelector((state: RootState) => state.account);
  const [clientType, setClientType] = useState("");
  const { incomeShare, editIncomeShareSuccess, editIncomeSharePending } =
    useSelector((state: RootState) => state.incomeShare);

  useEffect(() => {
    dispatch(resetClients());
    dispatch(getClientTypes());
  }, []);

  useEffect(() => {
    dispatch(
      getClients({
        page,
        searchText,
        from: dateRange.from,
        to: dateRange.to,
        clientType,
        clientNameSort,
      }),
    );
  }, [effect, page, clientNameSort]);

  const onCreate = () => {
    setMode(Actions.CREATE);
    setVisible(true);
  };

  const handlePageChange: PaginationProps["onChange"] = (p) => {
    setPage(p);
  };

  const onRangeChange: RangePickerProps["onChange"] = (dates, dateStrings) => {
    if (dates) setDateRange({ from: dateStrings[0], to: dateStrings[1] });
    else setDateRange({ from: "", to: "" });
    setPage(1);
    setEffect(!effect);
  };

  const handleCancel = () => {
    setFile(null);
    setActiveTabKey("1");
    setVisible(false);
    setOpen(false);
  };

  const UploadFile = (content: any) => {
    setFile(content);
  };

  const handleTrackFields = (filedsValue: any) => {
    const cData = filedsValue.map((item: any) => {
      return { id: item.id, share: item.share };
    });
    // console.log(cData);
    setTrackformValues(cData);
  };

  const panes = [
    {
      title: "Client Info",
      content: (
        <Form form={clientForm} {...formProps}>
          <ClientInfoForm
            onFileUpload={UploadFile}
            mode={mode}
            editData={editData}
            clientForm={clientForm}
          />
        </Form>
      ),
      key: "1",
    },
    {
      title: "Filters",
      content: (
        <Form form={filtersForm} {...formProps}>
          <FiltersForm
            key={refreshkey}
            mode={mode}
            editData={editData}
            filtersForm={filtersForm}
          />
        </Form>
      ),
      key: "2",
    },
    {
      title: "Income Share",
      content: (
        <Form form={incomeShareForm} {...formProps}>
          <IncomeShareForm
            mode={mode}
            incomeShare={incomeShare && incomeShare}
            incomeShareForm={incomeShareForm}
            clientForm={clientForm}
          />
        </Form>
      ),
      key: "3",
    },
    {
      title: "Specific Track Income",
      content: (
        <TrackIncomeForm handleTrackFields={handleTrackFields} mode={mode} />
      ),
      key: "4",
    },
    {
      title: "Bank A/C Details",
      content: (
        <Form form={bankForm} {...formProps}>
          <BankDetailsForm
            mode={mode}
            editData={editData}
            bankForm={bankForm}
          />
        </Form>
      ),
      key: "5",
    },
  ];

  const onTabChange = (key: string) => {
    setOpen(false);
    setActiveTabKey(key);
    if (mode === Actions.EDIT && key === "3") {
      dispatch(retrieveIncomeShare({ id: editData.income_share }));
    }
  };

  const bankAccountRequest = (fields: any) => {
    const bankAccountData = {
      account_name: fields.account_name,
      account_no: fields.account_no,
      bank_name: fields.bank_name,
      branch: fields.branch,
      routing_no: fields.routing_no,
      phone: fields.phone,
    };

    if (mode === Actions.CREATE)
      dispatch(createBankAccDetails(bankAccountData));
    else
      dispatch(
        editBankAccDetails({
          id: editData?.bank_account_detail,
          body: bankAccountData,
        }),
      );
  };

  const incomeShareRequest = (fields: any) => {
    // TODO change this spread operator and clean this code
    const incomeShareData = {
      ...(mode === Actions.CREATE
        ? { label_charge: fields.label_charge }
        : { label_charge: incomeShare.label_charge }),
      ...(mode === Actions.CREATE
        ? { artist_charge: fields.artist_charge }
        : { artist_charge: incomeShare.artist_charge }),
      ...(mode === Actions.CREATE
        ? { lyricist_charge: fields.lyricist_charge }
        : { lyricist_charge: incomeShare.lyricist_charge }),
      ...(mode === Actions.CREATE
        ? { composer_charge: fields.composer_charge }
        : { composer_charge: incomeShare.composer_charge }),
      ...(mode === Actions.CREATE ||
      (mode === Actions.EDIT && fields.label_charge)
        ? { temp_label_charge: fields.label_charge }
        : { temp_label_charge: null }),
      ...(mode === Actions.CREATE ||
      (mode === Actions.EDIT && fields.artist_charge)
        ? { temp_artist_charge: fields.artist_charge }
        : { temp_artist_charge: null }),
      ...(mode === Actions.CREATE ||
      (mode === Actions.EDIT && fields.lyricist_charge)
        ? { temp_lyricist_charge: fields.lyricist_charge }
        : { temp_lyricist_charge: null }),
      ...(mode === Actions.CREATE ||
      (mode === Actions.EDIT && fields.composer_charge)
        ? { temp_composer_charge: fields.composer_charge }
        : { temp_composer_charge: null }),
      // right_holder_charge: fields.right_holder_charge,
      // on_behalf_charge: fields.on_behalf_charge,
      effective_date: fields.effective_date
        ? moment(fields.effective_date).format()
        : moment(incomeShare.effective_date).format(),
      ...(mode === Actions.CREATE
        ? { clap_service_charge: fields.clap_service_charge }
        : { clap_service_charge: incomeShare.clap_service_charge }),
      temp_clap_service_charge: fields.clap_service_charge,
      invoice_name: fields.invoice_name,
      // is_service_charge_deduction_payment:
      //   fields.is_service_charge_deduction_payment,
      // is_service_charge_deduction_invoice:
      //   fields.is_service_charge_deduction_invoice,
      is_service_charge_visible: fields.is_service_charge_visible,
      is_service_charge_deduction_payment: false,
      is_service_charge_deduction_invoice: false,
      phone: fields.income_share_phone,
      address: fields.address,
      ...(mode === Actions.EDIT && { is_scheduled: true }),
    };

    if (mode === Actions.CREATE) dispatch(createIncomeShare(incomeShareData));
    else
      dispatch(
        editIncomeShare({ id: editData.income_share, body: incomeShareData }),
      );
  };

  const handleNext = async () => {
    if (mode === Actions.EDIT) {
      setActiveTabKey((Number(activeTabKey) + 1).toString());
      return;
    }
    try {
      if (activeTabKey === "1") await clientForm.validateFields();
      else if (activeTabKey === "2") await filtersForm.validateFields();
      else if (activeTabKey === "3") await incomeShareForm.validateFields();
      else if (activeTabKey === "5") await bankForm.validateFields();
    } catch (errorInfo) {
      return;
    }

    const clientFormFields = clientForm.getFieldsValue();
    const filtersFormFields = filtersForm.getFieldsValue();
    const incomeShareFormFields = incomeShareForm.getFieldsValue();
    const bankFormFields = bankForm.getFieldsValue();
    // console.log(
    //   "Validation passed. fields: ",
    //   clientFormFields,
    //   filtersFormFields,
    //   incomeShareFormFields,
    //   bankFormFields,
    // );

    if (activeTabKey === "2") {
      dispatch(resetExistedClientShare());
      // const typeName = clientTypes.map((item: any) => {
      //   if (clientFormFields.client_types.includes(item.id)) return item.label;
      //   return null;
      // });
      const type = clientTypes.find(
        (item: any) => clientFormFields.client_types === item.id,
      );

      // typeName.includes(AccountType.ARTIST)
      if (
        type.label === AccountType.MEMBER &&
        filtersFormFields.artists?.length === 1
      ) {
        dispatch(getIsClientShareExist({ id: filtersFormFields.artists[0] }));
      }
    }

    if (activeTabKey === "3") incomeShareRequest(incomeShareFormFields);
    if (activeTabKey === "5") {
      setClientFormValues(clientFormFields);
      setFiltersFormValues(filtersFormFields);
      setBankFormValues(bankFormFields);

      if (trackformValues.length)
        dispatch(addSpecificIncomeShare(trackformValues));
      else bankAccountRequest(bankFormFields);

      return;
    }

    setActiveTabKey((Number(activeTabKey) + 1).toString());
  };

  useEffect(() => {
    if (!visible) return;
    /* create; edit specific track income success */
    if (specificIncomeShareSuccess) {
      if (mode === Actions.CREATE) bankAccountRequest(bankFormValues);
      else {
        setOpen(false);
        message.success("Specific track income updated successfully");
      }
    }
  }, [specificIncomeShareSuccess]);

  const clientRequest = () => {
    const formData = new FormData();
    formData.append("name", clientFormValues.name.trim());
    formData.append("email", clientFormValues.email);
    // formData.append(
    //   "client_types_list",
    //   clientFormValues.client_types.join(", "),
    // );
    formData.append("client_types_list", clientFormValues.client_types);
    if (clientFormValues.contract_start_date)
      formData.append(
        "contract_start_date",
        moment(clientFormValues.contract_start_date).format(),
      );
    else if (mode === Actions.EDIT) formData.append("contract_start_date", "");
    if (clientFormValues.contract_end_date)
      formData.append(
        "contract_end_date",
        moment(clientFormValues.contract_end_date).format(),
      );
    else if (mode === Actions.EDIT) formData.append("contract_end_date", "");
    if (file) formData.append("client_logo", file as unknown as Blob);
    formData.append("status", clientFormValues.status);
    formData.append(
      "has_export_permission",
      clientFormValues.hasExportPermission,
    );
    formData.append(
      "is_email_notification_active",
      clientFormValues.isEmailNotification,
    );
    formData.append(
      "is_pdf_income_share_visible",
      clientFormValues.isIncomeSharePdf,
    );
    formData.append(
      "is_pdf_clap_charge_visible",
      clientFormValues.isClapChargePdf,
    );
    formData.append("labels", filtersFormValues.labels?.join(", "));
    formData.append("artists", filtersFormValues.artists?.join(", "));
    formData.append("lyricists", filtersFormValues.lyricists?.join(", "));
    formData.append("composers", filtersFormValues.composers?.join(", "));
    formData.append(
      "included_tracks",
      filtersFormValues.included_tracks?.join(", "),
    );
    formData.append(
      "excluded_tracks",
      filtersFormValues.excluded_tracks?.join(", "),
    );

    if (mode === Actions.CREATE) {
      formData.append("income_share", newIncomeShare?.data.id);
      formData.append("bank_account_detail", newBankAcc?.data.id);
      dispatch(createAccount(formData));
    } else {
      formData.append("income_share", editData?.income_share);
      formData.append("bank_account_detail", editData?.bank_account_detail);
      dispatch(editClientFilter({ id: editData?.id, body: formData }));
    }
  };

  const clientInfoRequest = () => {
    const formData = new FormData();
    formData.append("name", clientFormValues.name.trim());
    formData.append("email", clientFormValues.email);
    // formData.append(
    //   "client_types_list",
    //   clientFormValues.client_types.join(", "),
    // );
    // formData.append("client_types_list", clientFormValues.client_types);
    if (clientFormValues.contract_start_date)
      formData.append(
        "contract_start_date",
        moment(clientFormValues.contract_start_date).format(),
      );
    else formData.append("contract_start_date", "");
    if (clientFormValues.contract_end_date)
      formData.append(
        "contract_end_date",
        moment(clientFormValues.contract_end_date).format(),
      );
    else formData.append("contract_end_date", "");
    if (file) formData.append("client_logo", file as unknown as Blob);
    formData.append("status", clientFormValues.status);
    formData.append(
      "has_export_permission",
      clientFormValues.hasExportPermission,
    );
    formData.append(
      "is_email_notification_active",
      clientFormValues.isEmailNotification,
    );
    formData.append(
      "is_pdf_income_share_visible",
      clientFormValues.isIncomeSharePdf,
    );
    formData.append(
      "is_pdf_clap_charge_visible",
      clientFormValues.isClapChargePdf,
    );

    dispatch(editClientInfo({ id: editData?.id, body: formData }));
  };

  useEffect(() => {
    /* create; edit Bank account success */
    if (!visible) return;
    if (Number(activeTabKey) !== 5) return;
    if (mode === Actions.EDIT) {
      message.success("Bank details updated successfully");
      handleCancel();
      return;
    }
    clientRequest();
  }, [newBankAcc]);

  useEffect(() => {
    if (
      editIncomeShareSuccess &&
      activeTabKey === "3" &&
      mode === Actions.EDIT
    ) {
      message.success("Income share updated successfully");
      handleCancel();
    }
  }, [editIncomeSharePending]);

  useEffect(() => {
    // Action RETRY
    if (fulfilled && mode === Actions.RETRY) {
      message.success("Retrying to process. Please wait ..");
      setEffect(!effect);
      return;
    }
    if (!visible) return;
    /* create; edit account success */
    if (fulfilled) {
      if (mode === Actions.EDIT)
        message.success("Filters updated successfully");
      handleCancel();
      setEffect(!effect);
    }
  }, [pending]);

  useEffect(() => {
    if (clientInfoSuccess && mode === Actions.EDIT && activeTabKey === "1") {
      message.success("Client Info. updated successfully");
      handleCancel();
      setEffect(!effect);
    }
  }, [clientInfoPending]);

  const handleBack = () => {
    setActiveTabKey((Number(activeTabKey) - 1).toString());
  };

  const handleClientEdit = () => {
    // console.log("on Edit; ", activeTabKey);

    if (activeTabKey === "1") clientInfoRequest();
    if (activeTabKey === "2") clientRequest();
    if (activeTabKey === "3") {
      incomeShareRequest(incomeShareFormValues);
    }
    if (activeTabKey === "4" && trackformValues.length)
      dispatch(addSpecificIncomeShare(trackformValues));
    if (activeTabKey === "5") bankAccountRequest(bankFormValues);
  };

  const showPopconfirm = async () => {
    try {
      if (activeTabKey === "1") await clientForm.validateFields();
      else if (activeTabKey === "2") await filtersForm.validateFields();
      else if (activeTabKey === "3") await incomeShareForm.validateFields();
      else if (activeTabKey === "5") await bankForm.validateFields();
    } catch (errorInfo) {
      return;
    }
    const clientFormFields = clientForm.getFieldsValue();
    const filtersFormFields = filtersForm.getFieldsValue();
    const incomeShareFormFields = incomeShareForm.getFieldsValue();
    const bankFormFields = bankForm.getFieldsValue();

    setClientFormValues(clientFormFields);
    setFiltersFormValues(filtersFormFields);
    setIncomeShareFormValues(incomeShareFormFields);
    setBankFormValues(bankFormFields);

    setOpen(true);
  };
  const hidePopconfirm = () => setOpen(false);

  const handleFilterReload = () => {
    setRefreshKey(Date.now());
    hidePopconfirm();
  };

  useEffect(() => {
    if (clientFilterEditError) {
      hidePopconfirm();
    }
  }, [clientFilterEditError]);

  const handleSearch = (value: string) => {
    setSearchText(value);
    setPage(1);
    setEffect(!effect);
  };

  const onTypeChange = (value: string) => {
    if (value) setClientType(value);
    else setClientType("");
    setPage(1);
    setEffect(!effect);
  };

  const onEdit = (record: any) => {
    setMode(Actions.EDIT);
    setVisible(true);
    setEditData(record);
  };

  const onRetry = (record: any) => {
    setMode(Actions.RETRY);
    const formData = new FormData();
    formData.append("name", record.name.trim());
    formData.append("email", record.email);
    formData.append("client_types_list", record.client_types[0].id);
    if (record.contract_start_date)
      formData.append("contract_start_date", record.contract_start_date);
    else formData.append("contract_start_date", "");
    if (record.contract_end_date)
      formData.append("contract_end_date", record.contract_end_date);
    else formData.append("contract_end_date", "");
    // FIXME Need a solution for this image
    // if (file) formData.append("client_logo", file as unknown as Blob);
    formData.append("status", record.status);
    formData.append("labels", record.display_label?.join(", "));
    formData.append("artists", record.display_artist?.join(", "));
    formData.append("lyricists", record.display_lyricist?.join(", "));
    formData.append("composers", record.display_composer?.join(", "));
    formData.append(
      "included_tracks",
      record.display_included_tracks?.join(", "),
    );
    formData.append(
      "excluded_tracks",
      record.display_excluded_tracks?.join(", "),
    );

    formData.append("income_share", record.income_share);
    formData.append("bank_account_detail", record.bank_account_detail);
    dispatch(editClientFilter({ id: record.id, body: formData }));
  };

  // useEffect(() => {
  //   console.log("mode; ", mode, editData);
  // }, [mode]);

  /* FILTER VALIDATION on EDIT */
  const isUpdateDisable = () => {
    const filtersFormFields = filtersForm.getFieldsValue();
    if (mode === Actions.EDIT && activeTabKey === "2") {
      if (
        globalUtils.areEqualTwoArray(
          editData.display_label,
          filtersFormFields.labels,
        ) &&
        globalUtils.areEqualTwoArray(
          editData.display_artist,
          filtersFormFields.artists,
        ) &&
        globalUtils.areEqualTwoArray(
          editData.display_lyricist,
          filtersFormFields.lyricists,
        ) &&
        globalUtils.areEqualTwoArray(
          editData.display_composer,
          filtersFormFields.composers,
        ) &&
        globalUtils.areEqualTwoArray(
          editData.display_included_tracks,
          filtersFormFields.included_tracks,
        ) &&
        globalUtils.areEqualTwoArray(
          editData.display_excluded_tracks,
          filtersFormFields.excluded_tracks,
        )
      ) {
        return true;
      }
    }
    return false;
  };

  const labelsWatch = Form.useWatch("labels", filtersForm);
  const artistsWatch = Form.useWatch("artists", filtersForm);
  const lyricistsWatch = Form.useWatch("lyricists", filtersForm);
  const composersWatch = Form.useWatch("composers", filtersForm);
  const includedTracksWatch = Form.useWatch("included_tracks", filtersForm);
  const excludedTracksWatch = Form.useWatch("excluded_tracks", filtersForm);

  useEffect(() => {
    if (mode === Actions.EDIT && activeTabKey === "2") isUpdateDisable();
  }, [
    labelsWatch,
    artistsWatch,
    lyricistsWatch,
    composersWatch,
    includedTracksWatch,
    excludedTracksWatch,
  ]);

  const handleClientName = () => {
    setPage(1);
    if (clientNameSort === "name") setClientNameSort("-name");
    else setClientNameSort("name");
  };

  const controlledColumns = [
    {
      key: ClientKeys.NAME,
      dataIndex: ClientKeys.NAME,
      title: (
        <div
          className="flex justify-between cursor-pointer"
          onClick={handleClientName}
          aria-hidden="true"
        >
          <div>Client</div>
          <div className="opacity-60">
            {clientNameSort === "name" ? (
              <ArrowUpOutlined />
            ) : (
              <ArrowDownOutlined />
            )}
          </div>
        </div>
      ),
      position: 0,
      showSorterTooltip: false,
      width: 240,
      render: (value: any, record: any) => (
        <>{cells.AvatarCell(record?.client_logo, value)}</>
      ),
    },
  ];

  const actions = {
    title: "",
    key: "action",
    align: "right",
    className: "cursor-default",
    onCell: () => {
      return {
        onClick: (e: any) => {
          e.stopPropagation();
        },
      };
    },
    render: (_: any, record: any) =>
      record.payment_calculation_status ===
        (PaymentCalculationStatus.PROCESSED ||
          PaymentCalculationStatus.FAILED) && (
        <div className="text-secondary">
          <Dropdown
            overlay={
              <Menu
                className="min-w-[100px] rounded-[3px]"
                items={(() => {
                  switch (record.payment_calculation_status) {
                    case PaymentCalculationStatus.PROCESSED:
                      return [
                        {
                          label: (
                            <div
                              onClick={() => onEdit(record)}
                              aria-hidden="true"
                            >
                              Edit
                            </div>
                          ),
                          key: "EDIT",
                        },
                      ];

                    case PaymentCalculationStatus.FAILED:
                      return [
                        {
                          label: (
                            <div
                              onClick={() => onRetry(record)}
                              aria-hidden="true"
                            >
                              Retry
                            </div>
                          ),
                          key: "RETRY",
                        },
                      ];

                    default:
                      return [];
                  }
                })()}
              />
            }
            trigger={["click"]}
          >
            <button type="button">{icons.DotsVerticle()}</button>
          </Dropdown>
        </div>
      ),
  };

  const afterClose = () => {
    dispatch(resetClientFilterEditError());
    dispatch(resetIncomeShare());
    dispatch(resetExistedClientShare());
  };

  // const onHeaderClick = (column: any) => {
  //   console.log("onHeaderCell", column);
  // };

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="text-heading20">Clients</div>
        <div className="flex gap-2.5">
          <Button type="primary" onClick={onCreate}>
            Create Client
          </Button>
          {/* <Button type="primary">Create Income</Button> */}
          <Modal
            visible={visible}
            title={`${mode === Actions.CREATE ? "Create" : "Edit"} Client`}
            maskClosable={false}
            centered
            width={740}
            onCancel={handleCancel}
            destroyOnClose
            afterClose={afterClose}
            footer={[
              mode === Actions.EDIT && activeTabKey === "2" && (
                <Button
                  type="text"
                  icon={<ReloadOutlined onClick={handleFilterReload} />}
                />
              ),

              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>,
              mode === Actions.EDIT && (
                <Popconfirm
                  placement="topRight"
                  title="Are you sure to update?"
                  visible={open}
                  onConfirm={handleClientEdit}
                  okButtonProps={{
                    loading:
                      activeTabKey === "1"
                        ? (clientInfoPending as boolean)
                        : (pending as boolean),
                  }}
                  okText="Yes"
                  cancelText="No"
                  onCancel={hidePopconfirm}
                >
                  <Button
                    key="update"
                    type="primary"
                    disabled={isUpdateDisable()}
                    className={isUpdateDisable() ? "pl-2" : ""}
                    onClick={showPopconfirm}
                  >
                    Update
                  </Button>
                </Popconfirm>
              ),
              mode === Actions.CREATE && activeTabKey !== "1" && (
                <Button
                  key="back"
                  onClick={handleBack}
                  icon={<LeftOutlined className="text-xs" />}
                >
                  Back
                </Button>
              ),
              mode === Actions.CREATE && (
                <Button
                  key="submit"
                  type="primary"
                  loading={mode === Actions.CREATE && (pending as boolean)}
                  onClick={handleNext}
                >
                  {activeTabKey === "5" ? "Create" : "Next"}
                  {activeTabKey !== "5" && (
                    <RightOutlined className="text-xs" />
                  )}
                </Button>
              ),
            ]}
          >
            <div className="mx-6 mt-2">
              <Tabs
                activeKey={activeTabKey}
                onChange={onTabChange}
                tabBarStyle={{ marginBottom: "28px" }}
              >
                {panes.map((pane) => (
                  <Tabs.TabPane
                    tab={pane.title}
                    key={pane.key}
                    disabled={
                      mode === Actions.CREATE &&
                      Number(activeTabKey) <= Number(pane.key)
                    }
                    forceRender={
                      mode === Actions.EDIT && Number(pane.key) === 2
                    }
                  >
                    {pane.content}
                  </Tabs.TabPane>
                ))}
              </Tabs>
            </div>
          </Modal>
        </div>
      </div>
      <div className="mt-5 mb-4 flex justify-between">
        <div className="space-x-4">
          <SearchComponent handleSearch={handleSearch} />
          <RangePicker onChange={onRangeChange} className="w-[256px]" />
          <Select
            placeholder="Client Type"
            className="w-[190px]"
            showSearch
            allowClear
            onChange={onTypeChange}
          >
            {clientTypes.map((type: any) => (
              <Option key={type.id} value={type.label}>
                {type.label}
              </Option>
            ))}
          </Select>
        </div>
      </div>
      <div>
        <Table
          rowKey={(record: any) => {
            return record.id;
          }}
          rowClassName="cursor-pointer"
          onRow={(record) => {
            return {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onClick: (event) => {
                if (
                  record.payment_calculation_status ===
                  PaymentCalculationStatus.PROCESSED
                )
                  navigate(record.id, { state: record });
                else
                  message.warning(
                    "Please wait until the payment calculation is processed",
                  );
              },
            };
          }}
          columns={tableUtils.buildColumns(
            clients,
            ClientColumn,
            actions,
            clients.length && controlledColumns,
          )}
          dataSource={clients}
          pagination={false}
          size="middle"
          scroll={{ x: 1024 }}
          loading={{
            spinning: clientsPending as boolean,
            indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
          }}
        />
      </div>
      <div className="text-right mt-4">
        <Pagination
          current={page}
          onChange={handlePageChange}
          total={clientsCount}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default Accounts;
